import CategoryService from '../../lib/api/category.service';

export async function fetchCategories({ commit }) {
  const response = await CategoryService.getAll();

  if (response.status === 200) {
    commit('updateCategories', response.data);
  }
}
